import type { FormCompositionHook } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';

type Props = {
  formComposition: FormCompositionHook<'aimApplications'>;
};

export const AimApplicationsSubTab = ({ formComposition }: Props) => (
  <div className='flex flex-col flex-1 gap'>
    {formComposition.renderGroup('aimApplications')}
  </div>
);
